import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Result } from "./Result";
import { getResult } from "../data/quizData";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SharedResult = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/submissions/${id}/result`)
      .then((res) => setData(res.data))
      .catch(() => setNotFound(true));
  }, [id]);

  const daysSince = data
    ? Math.floor((Date.now() - new Date(data.timestamp).getTime()) / 86400000)
    : 0;
  const daysLabel = daysSince <= 0 ? "today" : daysSince === 1 ? "yesterday" : `${daysSince} days ago`;

  return (
    <div className="min-h-screen w-full bg-[#FAF7F2] text-[#2C221E] flex flex-col items-center selection:bg-[#B25E3B]/20">
      <header className="w-full max-w-xl mx-auto flex items-center justify-center py-4 px-4 sm:px-6 border-b border-[#E9DFD6]/70 mb-2">
        <a
          href="https://www.grayrootssociety.com"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="shared-header-brand-link"
        >
          <img src="/banner.png" alt="Gray Roots Society — Head Up, Crown On" className="h-10 sm:h-12 w-auto" />
        </a>
      </header>
      <main className="w-full max-w-xl mx-auto px-4 sm:px-6 py-6 flex flex-col flex-1">
        {notFound && (
          <div data-testid="shared-result-not-found" className="flex flex-col flex-1 items-center justify-center text-center">
            <h1 className="font-serif-display text-3xl text-[#2C221E] mb-3">This link has wandered off.</h1>
            <p className="text-base text-[#85746C]">
              We couldn't find that result. It may have been a typo in the link — or you can simply take the quiz again.
            </p>
          </div>
        )}
        {!data && !notFound && (
          <p data-testid="shared-result-loading" className="text-center text-[#85746C] pt-20">One moment…</p>
        )}
        {data && (
          <>
            <div
              data-testid="welcome-back-nudge"
              className="animate-fade-up rounded-2xl bg-[#FBEBE4] border border-[#B25E3B]/20 p-5 mb-8"
            >
              <p className="font-serif-display text-xl text-[#2C221E] mb-1">Welcome back.</p>
              <p data-testid="days-since-line" className="text-xs uppercase tracking-[0.15em] font-semibold text-[#B25E3B] mb-2">
                You found your first step {daysLabel}.
              </p>
              <p className="text-sm sm:text-base text-[#5A4D46] leading-relaxed">
                Your next step is still right where you left it. And whenever you're ready
                for steps two through thirty,{" "}
                <a href="#booking-cta-card" className="text-[#B25E3B] font-semibold underline underline-offset-2">
                  your Reinvention Kickstarter is waiting
                </a>
                .
              </p>
            </div>
            <Result
              result={getResult(data.q1, data.q2)}
              submissionId={id}
              showEmailCapture={!data.has_email}
              emailSent={data.has_email}
            />
          </>
        )}
      </main>
      <footer className="w-full max-w-xl mx-auto px-4 sm:px-6 py-6 text-center">
        <p className="text-xs text-[#85746C]">Head up, crown on · Gray Roots Society</p>
      </footer>
    </div>
  );
};
